import * as React from "react";
import { Col } from "antd";
import { FormComponentProps } from "antd/lib/form";
import { SelectCourtType } from "./SelectCourtType";
import { SelectCourt } from "./SelectCourt";

interface ISelectCourtTypeCourtCorrectionType {
  colLgSize: number;
  colMdSize: number;

  onChangeCourt: (id: number) => void;
  onChangeCourtType?: (id: number) => void;

  courtId: number;
  courtTypeId?: number;

  showCorrectionType?: boolean;
  isTypeRequired: boolean;
  isCourtRequired: boolean;
  filledFields: boolean;
}

export function SelectCourtAndCourtType(props: ISelectCourtTypeCourtCorrectionType & FormComponentProps) {
  return (
    <>
      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: props.colMdSize }} lg={{ span: props.colLgSize }}>
        <SelectCourtType
          isTypeRequired={props.isTypeRequired}
          value={props.courtTypeId}
          onChange={props.onChangeCourtType}
          form={props.form} />
      </Col>

      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: props.colMdSize }} lg={{ span: props.colLgSize }}>
        <SelectCourt
          isCourtRequired={props.isCourtRequired}
          value={props.courtId}
          courtTypeId={props.courtTypeId}
          onChange={props.onChangeCourt}
          form={props.form}
          onlyActive
        />
      </Col>
    </>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourtAndCourtType.tsx